import { render, staticRenderFns } from "./Datasets.vue?vue&type=template&id=9cdfad9e&scoped=true&"
import script from "./Datasets.vue?vue&type=script&lang=js&"
export * from "./Datasets.vue?vue&type=script&lang=js&"
import style0 from "./Datasets.vue?vue&type=style&index=0&id=9cdfad9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdfad9e",
  null
  
)

export default component.exports